import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCompanyProfile } from "@/context/CompanyProfileContext";
import { buildCompanyNav } from "@/lib/companyProfile";

/* Navigasi Company-Profile-aware — dirender Header hanya saat mode ON.
   Anchor section hanya untuk section yang tampil; "Toko" → /katalog existing. */
export function CompanyNav() {
  const { mode, sectionOrder, catalogPath } = useCompanyProfile();
  const location = useLocation();
  if (mode !== "company_profile") return null;
  const items = buildCompanyNav(sectionOrder, catalogPath);
  const isActive = (it) => (it.anchor ? location.pathname === "/" && location.hash === `#${it.anchor}`
    : it.to === "/" ? location.pathname === "/" && !location.hash : location.pathname.startsWith(it.to));
  return (
    <nav className="cp-nav border-t border-[color:var(--color-border)]" aria-label="Navigasi Company Profile" data-testid="company-nav">
      <div className="storefront-container flex items-center gap-1 overflow-x-auto no-scrollbar">
        {items.map((it) => (
          <Link key={it.key} to={it.to} className={`cp-nav-link ${isActive(it) ? "is-active" : ""}`} data-testid={`company-nav-${it.key}`}>{it.label}</Link>
        ))}
      </div>
    </nav>
  );
}
